import createPersistedState from 'use-persisted-state';

export default function createSessionStorageState(key) {
    return createPersistedState(key, getProvider());
}

const getProvider = () => {
    if (typeof global !== 'undefined' && global.sessionStorage) {
      return global.sessionStorage;
    }
    // eslint-disable-next-line no-undef
    if (typeof globalThis !== 'undefined' && globalThis.sessionStorage) {
      // eslint-disable-next-line no-undef
      return globalThis.sessionStorage;
    }
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return window.sessionStorage;
    }
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage;
    }
    return null;
  };